"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useStyleOptions;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useStyleOptions() {
  return [(0, _useWebChatAPIContext.default)().styleOptions];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTdHlsZU9wdGlvbnMudHMiXSwibmFtZXMiOlsidXNlU3R5bGVPcHRpb25zIiwic3R5bGVPcHRpb25zIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ0E7Ozs7QUFFZSxTQUFTQSxlQUFULEdBQWlEO0FBQzlELFNBQU8sQ0FBQyxxQ0FBdUJDLFlBQXhCLENBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU3RyaWN0U3R5bGVPcHRpb25zIH0gZnJvbSAnLi4vU3R5bGVPcHRpb25zJztcbmltcG9ydCB1c2VXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL2ludGVybmFsL3VzZVdlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlU3R5bGVPcHRpb25zKCk6IFtTdHJpY3RTdHlsZU9wdGlvbnNdIHtcbiAgcmV0dXJuIFt1c2VXZWJDaGF0QVBJQ29udGV4dCgpLnN0eWxlT3B0aW9uc107XG59XG4iXX0=